export default "dist/7ef914895361380fd3d36361b050e4b5.otf";